<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
      </div>
    </div>

    <div class="filtro-component" v-if="!loading">
      <b-card>
        <div
          class="row cursor-pointer"
          id="header-filtro"
          @click="filtroExpandido = !filtroExpandido"
        >
          <div
            class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center"
          >
            <h4
              class="font-size-16 mb-0 text-uppercase"
              style="font-weight: 600"
            >
              Filtro de Clientes Rurais
            </h4>
          </div>

          <div
            class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end order-1 order-md-2 mb-2 mb-md-0"
          >
            <div class="d-flex">
              <b-button
                variant="success"
                class="me-2"
                @click="redirectToCadastroEdicao"
              >
                <i class="fa fa-solid fa-plus me-2"></i>
                <span>Novo Cliente</span>
              </b-button>
              <div>
                <i
                  :class="
                    filtroExpandido
                      ? 'mdi mdi-filter'
                      : 'mdi mdi-filter-outline'
                  "
                  class="icone-accordion"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Conteúdo do filtro -->
        <b-collapse v-model="filtroExpandido" class="mt-3">
          <div class="row">
            <!-- Cooperado -->
            <div class="col-md-3">
              <b-form-group
                label="Cooperado"
                :state="getState('selecaoCooperado')"
                invalid-feedback="O campo cooperado é obrigatório"
              >
                <multiselect
                  label="name"
                  track-by="name"
                  :taggable="false"
                  :max-height="200"
                  :allowEmpty="false"
                  :disabled="cooperadoDisabled"
                  :options="cooperadoLkp"
                  selected-label=""
                  v-model="selecaoCooperadoVM"
                  @input="carregarClienteRural"
                  placeholder="Selecione um Cooperado"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noResult">Nenhum cooperado encontrado</span>
                  <span slot="noOptions">Nenhum Cooperado disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Cliente Rural -->
            <div class="col-md-3">
              <b-form-group label="Cliente Rural">
                <multiselect
                  label="name"
                  track-by="name"
                  :max-height="200"
                  :options="clienteRuralLkp"
                  selected-label=""
                  :loading="loadingClienteRural"
                  v-model="selecaoClienteRuralVM"
                  placeholder="Selecione um cliente rural"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noResult">Nenhum Cliente Rural encontrado</span>
                  <span slot="noOptions">Nenhum Cliente Rural disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- CPF / CNPJ -->
            <div class="col-md-3">
              <b-form-group class="mb-3" label="CPF / CNPJ">
                <multiselect
                  label="cpfCnpj"
                  track-by="cpfCnpj"
                  v-model="selecaoCpfCnpjVM"
                  :options="filteredOptions"
                  selected-label=""
                  :custom-label="formatCpfCnpj"
                  @search-change="updateSearch"
                  placeholder="Selecione CPF / CNPJ"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noResult">Nenhum CPF / CNPJ encontrado</span>
                  <span slot="noOptions">Nenhum CPF / CNPJ disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Mês Aniversário -->
            <div class="col-md-3">
              <b-form-group label="Mês Aniversário">
                <multiselect
                  label="label"
                  :options="mes"
                  track-by="value"
                  v-model="mesAnoVM"
                  selected-label=""
                  placeholder="Selecione o mês"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noOptions">
                    Nenhum mês de aniversário disponível
                  </span>
                  <span slot="noResult">
                    Nenhum mês de aniversário encontrado
                  </span>
                </multiselect>
              </b-form-group>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Email">
                <b-form-input
                  type="text"
                  v-model.trim="emailVM"
                  placeholder="Digite um email"
                />
              </b-form-group>
            </div>

            <!-- Município - UF -->
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Municipio - UF">
                <multiselect
                  label="name"
                  track-by="name"
                  selected-label=""
                  v-model="selecaoMunicipioVM"
                  :options="selecaoMunicipioLkp"
                  placeholder="Selecione o município"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noResult">Nenhum município encontrado</span>
                  <span slot="noOptions">Nenhum município disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Projeto Unicampo -->
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Projeto Unicampo">
                <multiselect
                  label="name"
                  track-by="name"
                  v-model="selecaoProjetoVM"
                  :options="selecaoProjetoLkp"
                  selected-label=""
                  placeholder="Selecione um projeto unicampo"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noResult">Nenhum projeto encontrado</span>
                  <span slot="noOptions">Nenhum projeto disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Safra -->
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Safra">
                <multiselect
                  label="name"
                  track-by="name"
                  v-model="selecaoSafraVM"
                  :options="selecaoSafraLkp"
                  selected-label=""
                  placeholder="Selecione uma safra"
                  deselect-label=""
                  select-label=""
                >
                  <span slot="noResult">Nenhuma safra encontrada</span>
                  <span slot="noOptions">Nenhuma safra disponível</span>
                </multiselect>
              </b-form-group>
            </div>
          </div>

          <!-- Botões -->
          <div class="row">
            <div class="col-12 d-flex align-items-center gap-2">
              <b-button class="button-filtro" @click="limparFormulario">
                <i class="mdi mdi-broom align-middle me-1"></i>
                <span>Limpar</span>
              </b-button>

              <b-button
                variant="primary"
                @click="clicarParaFiltrar"
                :disabled="disabledFiltro"
                class="button-filtro d-flex align-items-center justify-content-center"
              >
                <template v-if="loadingButton">
                  <b-spinner small variant="light" label="Carregando..." />
                </template>

                <template v-else>
                  <i class="mdi mdi-filter-outline me-1"></i>
                  <span>Filtrar</span>
                </template>
              </b-button>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script lang="js">
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { filtrosClientesRuraisHelper } from "@/store/helpers/vuex/astec";
import { paginacaoClientesRuraisHelper } from "@/store/helpers/vuex/astec";

const MESES_DO_ANO = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" }
];

export default {
  name: "FiltroClientesRurais",
  mixins: [clienteRuralMixin],
  props: {
    redirectToCadastroEdicao: Function
  },
  components: {
    Multiselect
  },

  data() {
    return {
      loading: true,
      mes: MESES_DO_ANO,
      searchQuery: "",
      submit: false,
      cdPessoa: "",
      disabledFiltro: false,
      filtroExpandido: true,
      loadingClienteRural: false,

      cooperadoLkp: [],
      clienteRuralLkp: [],
      selecaoMunicipioLkp: [],
      selecaoProjetoLkp: [],
      selecaoSafraLkp: [],
      loadingButton: false,
      filtroClicadoPeloBotao: false
    };
  },

  computed: {
    ...filtrosClientesRuraisHelper({
      state: [
        "selecaoCooperado",
        "selecaoClienteRural",
        "selecaoCpfCnpj",
        "mesAno",
        "email",
        "selecaoMunicipio",
        "selecaoProjeto",
        "selecaoSafra"
      ],
      getters: ["filtroClientesRurais", "hasFiltrosAtivos"],
      actions: []
    }).computed,

    selecaoCooperadoVM: {
      get() {
        return this.selecaoCooperado;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoCooperado", valor: val });
      }
    },

    selecaoClienteRuralVM: {
      get() {
        return this.selecaoClienteRural;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoClienteRural", valor: val });
      }
    },

    selecaoCpfCnpjVM: {
      get() {
        return this.selecaoCpfCnpj;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoCpfCnpj", valor: val });
      }
    },

    mesAnoVM: {
      get() {
        return this.mesAno;
      },
      set(val) {
        this.setFiltroCampo({ campo: "mesAno", valor: val });
      }
    },

    emailVM: {
      get() {
        return this.email;
      },
      set(val) {
        this.setFiltroCampo({ campo: "email", valor: val });
      }
    },

    selecaoMunicipioVM: {
      get() {
        return this.selecaoMunicipio;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoMunicipio", valor: val });
      }
    },

    selecaoProjetoVM: {
      get() {
        return this.selecaoProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoProjeto", valor: val });
      }
    },

    selecaoSafraVM: {
      get() {
        return this.selecaoSafra;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoSafra", valor: val });
      }
    },

    cooperadoDisabled() {
      return this.cooperadoLkp.length === 1;
    },
    filteredOptions() {
      if (!this.searchQuery) return this.clienteRuralLkp;
      const normalizedSearch = this.normalizeCpfCnpj(this.searchQuery);

      return this.clienteRuralLkp.filter(option => {
        const normalizedOption = this.normalizeCpfCnpj(option.cpfCnpj);
        return normalizedOption.includes(normalizedSearch);
      });
    }
  },

  methods: {
    ...filtrosClientesRuraisHelper({
      state: [],
      getters: [],
      actions: [
        "setFiltroClientesRurais",
        "setFiltroCampo",
        "setOpcoesFiltro",
        "limparFiltrosClientesRurais"
      ]
    }).methods,

    ...paginacaoClientesRuraisHelper({
      actions: ["resetarPaginacao"]
    }).methods,

    async clicarParaFiltrar() {
      this.filtroClicadoPeloBotao = true;
      await this.emitirFiltro();
    },

    getState(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      }
      return null;
    },

    async buscarDados() {
      await this.buscarLkpSafra();
      await this.getNomeRazaoUsuario();
      await this.buscarMunicipioUf();
      await this.buscarLkpProjeto();
      await this.buscarLkpCooperado();
      await this.carregarClienteRural();
      await this.verificarCooperado();
      this.loading = false;

      if (this.hasFiltrosAtivos) {
        await this.carregarFiltrosDoVuex();
      }
    },

    async carregarFiltrosDoVuex() {
      if (this.selecaoCooperado) {
        await this.carregarClienteRural();
        if (this.selecaoClienteRural) {
          const clienteEncontrado = this.clienteRuralLkp.find(
            cliente => cliente.value === this.selecaoClienteRural.value
          );
          if (clienteEncontrado) {
            this.selecaoCpfCnpj = clienteEncontrado;
          }
        }
      }
    },

    async carregarClienteRural() {
      if (this.selecaoCooperado) {
        this.clienteRuralLkp = [];
        this.loadingClienteRural = true;
        try {
          const response = await this.$http.get(
            "/api/astec/getLkpClienteRuralProjetos/" +
              this.selecaoCooperado.value
          );
          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name: cliente.DISPLAY,
              value: cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ
            };
          });

          if (
            this.selecaoClienteRural &&
            !this.clienteRuralLkp.find(
              c => c.value === this.selecaoClienteRural.value
            )
          ) {
            this.selecaoClienteRural = null;
            this.selecaoCpfCnpj = null;
          }
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingClienteRural = false;
      }
    },

    async verificarFiltro(filtro) {
      this.selecaoCooperado = this.cooperadoLkp.find(
        el => el.value == filtro.cdCooperado
      );
      if (this.selecaoCooperado) {
        this.setFiltroCampo({
          campo: "selecaoCooperado",
          valor: this.selecaoCooperado
        });
      }

      await this.carregarClienteRural();
      if (filtro.sqCliente) {
        this.selecaoClienteRural = this.clienteRuralLkp.find(
          el => el.value == filtro.sqCliente
        );
        this.selecaoCpfCnpj = this.selecaoClienteRural;
      }

      this.mesAno =
        this.mes.find(el => el.value == filtro.mes_aniversario) || null;
      this.email = filtro.e_mail || "";
      this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
        el => el.value == filtro.sq_regiao
      );
      this.selecaoProjeto = this.selecaoProjetoLkp.find(
        el => el.value == filtro.cd_projeto
      );
      this.selecaoSafra = this.selecaoSafraLkp.find(
        el => el.name == filtro.safra
      );

      const filtrosParaSalvar = {
        selecaoCooperado: this.selecaoCooperado,
        selecaoClienteRural: this.selecaoClienteRural,
        selecaoCpfCnpj: this.selecaoCpfCnpj,
        mesAno: this.mesAno,
        email: this.email,
        selecaoMunicipio: this.selecaoMunicipio,
        selecaoProjeto: this.selecaoProjeto,
        selecaoSafra: this.selecaoSafra
      };

      this.setFiltroClientesRurais(filtrosParaSalvar);
      this.emitirFiltro();
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length === 1) {
        this.selecaoCooperadoVM = this.cooperadoLkp[0];
      } else if (
        this.cdPessoa &&
        this.cooperadoLkp &&
        this.cooperadoLkp.length > 0
      ) {
        const cooperadoEncontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.cdPessoa
        );
        if (cooperadoEncontrado) {
          this.selecaoCooperadoVM = cooperadoEncontrado;
        }
      }
    },

    FiltrarClientesRurais() {
      const dados = {
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        sqCliente:
          this.selecaoClienteRural?.value || this.selecaoCpfCnpj?.value || null,
        mes_aniversario: this.mesAno ? this.mesAno.value : "",
        e_mail: this.email ? this.email.trim() : "",
        sq_regiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cd_projeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        safra: this.selecaoSafra ? this.selecaoSafra.name : null
      };
      return dados;
    },

    async emitirFiltro() {
      this.submit = true;
      this.loadingButton = true;
      this.disabledFiltro = true;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.loadingButton = false;
        this.disabledFiltro = false;
        return;
      }

      if (this.filtroClicadoPeloBotao) {
        await this.resetarPaginacao();
        this.filtroClicadoPeloBotao = false;
      }

      const filtro = this.FiltrarClientesRurais();

      // Cria um fallback caso ninguém chame o callback
      let callbackChamado = false;
      const callback = () => {
        if (!callbackChamado) {
          this.loadingButton = false;
          this.disabledFiltro = false;
          this.filtroExpandido = true;
          callbackChamado = true;
        }
      };

      this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", filtro);
      this.$emit("clientesRuraisFiltrados", filtro, callback);

      setTimeout(callback, 500);
    },

    limparFormulario() {
      this.setFiltroClientesRurais({
        selecaoClienteRural: null,
        selecaoCpfCnpj: null,
        mesAno: null,
        email: "",
        selecaoMunicipio: null,
        selecaoProjeto: null,
        selecaoSafra: null
      });

      this.resetarPaginacao();
      this.searchQuery = "";
      this.clienteRuralLkp = [];
      this.loadingClienteRural = false;

      this.submit = false;
      this.$v.$reset();

      this.$emit("clientesRuraisFiltrados", null, () => {
        this.loadingButton = false;
        this.disabledFiltro = false;
      });
    },

    formatCpfCnpj(option) {
      return option.cpfCnpj;
    },

    normalizeCpfCnpj(value) {
      if (!value) return "";
      return value.replace(/\D/g, "");
    },

    updateSearch(query) {
      this.searchQuery = query;
    }
  },

  validations: {
    selecaoCooperado: { required }
  },

  async mounted() {
    await this.buscarDados();
    if (this.$store.state.filtroClienteRuralAstec) {
      await this.verificarFiltro(this.$store.state.filtroClienteRuralAstec);
    }
  }
};
</script>

<style scoped>
.icone-accordion {
  font-size: 24px;
}

.button-filtro {
  min-width: 90px;
  min-height: 40px;
}
</style>
